import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Card, PageHeader, Button, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/version_table'
import VersionsService from '../../network/services/version'
import { serialize } from '../../network/request'
import VersionsTable from './VersionTable'

const VersionsPage = () => {
  const navigate = useNavigate()
  const primaryAction = (
    <Button
      key="add"
      type="primary"
      onClick={() => {
        navigate('new')
      }}
    >
      Create Version
    </Button>
  )

  return (
    <PageHeader title="All Versions" extra={[primaryAction]}>
      <Card>
        <VersionsTableWrapper />
      </Card>
    </PageHeader>
  )
}

const VersionsTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(VersionsService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  console.log(response)

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = VersionsService.toPaginate(response)

  return (
    <>
      <VersionsTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <VersionsTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default VersionsPage
